import { Link, useParams } from "react-router-dom";
import { dramas } from "@/mocks/dramas";
import { genreTags } from "@/mocks/categories";
import Breadcrumb from "@/components/feature/Breadcrumb";
import DramaListView from "@/components/feature/DramaListView";
import { usePageMeta } from "@/hooks/usePageMeta";

const wrap = "mx-auto w-full max-w-[1280px] px-4 md:px-6";

export default function TagsPage() {
  const { tagName = "" } = useParams();
  const meta = genreTags.find((t) => t.name === tagName);
  const list = dramas.filter((d) => d.tags.includes(tagName));

  usePageMeta(
    `${tagName}标签 - 泰剧腐剧双男主`,
    `${tagName}标签下的泰国双男主剧集合集，${meta?.desc ?? "为你精选该主题相关的优质作品。"}`,
  );

  return (
    <div className={wrap}>
      <div className="border-b border-background-200 pt-6 pb-5">
        <Breadcrumb
          items={[{ label: "首页", to: "/" }, { label: "标签" }, { label: tagName }]}
        />
        <h1 className="mt-3 flex items-center gap-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
            <i className={`${meta?.icon ?? "ri-price-tag-3-line"} text-xl`}></i>
          </span>
          {tagName}
        </h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
          {meta?.desc ?? "该标签下的相关作品合集，点击卡片即可查看详细剧情与角色介绍。"}
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {genreTags.map((t) => (
            <Link
              key={t.name}
              to={`/tags/${t.name}`}
              className={`rounded-full px-3 py-1 text-xs transition-colors whitespace-nowrap cursor-pointer ${
                t.name === tagName
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {t.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="mt-6 pb-4">
        <DramaListView
          dramas={list}
          emptyTitle={`暂无「${tagName}」相关作品`}
          emptyDescription="该标签下的作品还在整理中，先看看其他标签的推荐吧。"
        />
      </div>
    </div>
  );
}